import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true
})

/**
 * FilterPipe enables filtering of a list of items based on any number of its properties
 * (even nested ones, as many levels in as needed)
 * For example, consider a list of items of type:
 * a{
 *   b{
 *     c{
 *       d:''
 *     }
 *     e:''
 *    }
 *   f:''
 * }
 * We can filter objects of type 'a' by any of it's (nested) properties - d,e,f.
 * In html, we need pass the arguments as - " (list of items) | filter : 'b.c.d' : 'b.e' : 'f' "
 * To check for all array elements at any level, pass arguments as " a.b[].c " where b is an array, and we
 * need to check value of c in all the b objects
 * Even for specific array elements, pass it with '.'s in between. Ex- 'a.b.0.c' for a.b[0].c
 */

export class FilterPipe implements PipeTransform {

  helper(property: string, item: any, term: string) {
    if (property.indexOf('.') !== -1) {
      return (property.split('.').reduce((o, i) => o[i], item).toString().toUpperCase().indexOf(term.toUpperCase()) !== -1);
    } else if (item[property]) {
      return (item[property].toString().toUpperCase().indexOf(term.toUpperCase()) !== -1);
    }
    return null;
  }

  transform(items: any[], ...propertyNames: string[]): any {
    const size = propertyNames.length;
    if (items && items.length > 0 && size > 1) {
      const term: string = propertyNames[size - 1];
      if (term) {
        return items.filter(item => {
          let flag = false;
          propertyNames.forEach((property, index) => {
            if ((index !== size - 1)) {
              if (property.indexOf('[]') !== -1) {
                index = property.indexOf('[]');
                const properties: string[] = [];
                const len = property.substring(0, index).split('.')
                  .reduce((o, i) => o[i], item).length;
                for (let looper = 0; looper < len; looper++) {
                  properties.push(
                    property.substring(0, index) + '.' + looper + property.substring(index + 2)
                  );
                }
                properties.forEach(prop => {
                  flag = this.helper(prop, item, term) || flag;
                });
              } else {
                flag = this.helper(property, item, term) || flag;
              }
            }
          });
          return flag;
        });
      } else {
        return items;
      }
    } else {
      return items;
    }
  }
}